import React, { Component } from 'react';
import { Table, Row, InputNumber, Popconfirm, Button, Select, message, Spin, Alert } from 'antd';
import moment from 'moment';
import './index.scss';
import imgSave from "../../saveImg";
import { data2_3 } from './data';
import Auth from "../../Auth";
import Compared from "../../Compared";
import FileSaver from "file-saver";
import IsLableAuth from "../../IsLableAuth";
import _ from "lodash";
import { compute, saveAllData } from './compute'

const Option = Select.Option;

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY'),
            data: [],
            loading: true,
            loadingSave: false,
            dateData: [],
            print: false,
            dataSelect: []
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        let date = Number(this.state.date || "0");
        let dateData = [];
        let len = date - 2018 + 3;
        for (let i = 0; i < len; i++) {
            dateData.push((2018 + i).toString())
        }
        this.setState({ dateData });
    }



    computeNum = (data) => {
        data = compute(data);
        // 计算三
        this.setState({
            data
        }, () => {
            this.onSave();
        });
    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data2_3);
        let data = JSON.parse(dataBegin).filter((x, i) => i != 0);
        let dataSelect = JSON.parse(dataBegin).filter((x, i) => i == 0);
        fetch(`/_2_3_info?year=${date}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data.filter((x, i) => i != 0);
                dataSelect = x.data.filter((x, i) => i == 0);
            }
            if (x.msg.last && x.msg.last.length) {
                data = x.msg.last.filter((x, i) => i != 0 && i <= data.length).map((v, i) => {
                    delete v.id;
                    delete v.month;
                    if (data[i].id) v.id = data[i].id;
                    return {
                        ...v,
                        'nextJan': _.get(x.msg.data2_1, `${i + 1}.Jan`),
                        'nextFeb': _.get(x.msg.data2_1, `${i + 1}.Feb`),
                        'nextMar': _.get(x.msg.data2_1, `${i + 1}.Mar`),
                    }
                });
                dataSelect = x.msg.last.filter((x, i) => i == 0).map((v, i) => {
                    delete v.id;
                    delete v.month;
                    if (dataSelect[i].id) v.id = dataSelect[i].id;
                    return v
                });
            }
            this.setState({ loading: false, dataSelect });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }
    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = date
        let data = [...this.state.dataSelect.map(x => ({ ...x, year })), ...this.state.data.map(x => ({ ...x, year }))];
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_2_3', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }

            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            message.error('保存失败' + JSON.stringify(err));
            console.error(err);
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table2_3', 1.5, '2.30', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    onExpoetExcel = () => {
        this.setState({ print: true, loading: true }, () => {
            const name = `Last Year P&L Analysis (Whole Year Actual) 前一年度损益分析 （去年实际）${moment(this.state.date).format('YYYY-MM')}`;
            const innerHtml = `
              <caption>${name}</caption>
              ${document.getElementById('table').innerHTML.replace(/<table class="">/g, '<table border="1">')}
            `;

            var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
            var blob = new Blob([html], { type: "application/vnd.ms-excel" });
            FileSaver.saveAs(blob, `${name}.xls`);
            this.setState({ print: false, loading: false });
        });
    }

    render() {
        const { data, loading, date } = this.state;
        const width = document.body.offsetWidth > 3025 ? document.body.offsetWidth - 2600 : 425;
        const inputIndex = [0, 1, 5, 6, 7, 9, 11, 13, 15, 17, 21, 24, 25, 26, 28, 29, 30, 31];
        const percentData = [2, 10, 12, 14, 16, 18, 20, 22];
        const totalData = [8, 22, 23, 27];
        const dataSelect = this.state.dataSelect;
        const print = this.state.print;
        const columns = [{
            align: "center",
            title: <div>P&L Index <br />  损益指数</div>,
            width,
            fixed: print ? false : "left",
            dataIndex: 'name',
            key: 'name',
            width,
            render: (text, record, index) => {
                return (
                    <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}
                        dangerouslySetInnerHTML={{ __html: text }}
                    ></div >
                )
            }
        }, {
            title: 'Jan 一月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Jan', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Jan',
                    key: 'Jan',
                    render: (text, record, index) => {
                        const title = [`Jan 一月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Jan', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }]
        }, {
            title: 'Feb 二月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Feb', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Feb',
                    key: 'Feb',
                    render: (text, record, index) => {
                        const title = [`Feb 二月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Feb', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }]
        }, {
            title: 'Mar 三月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Mar', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Mar',
                    key: 'Mar',
                    render: (text, record, index) => {
                        const title = [`Mar 三月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Mar', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }]
        }, {
            title: 'Apr 四月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Apr', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Apr',
                    key: 'Apr',
                    render: (text, record, index) => {
                        const title = [`Apr 四月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Apr', title, sqlName: "_2_3", name: record.name, type: 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared>
                        )
                    }
                }]
            }]
        }, {
            title: 'May 五月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.May', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'May',
                    key: 'May',
                    render: (text, record, index) => {
                        const title = [`May 五月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'May', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }]
        }, {
            title: 'Jun 六月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Jun', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Jun',
                    key: 'Jun',
                    render: (text, record, index) => {
                        const title = [`Jun 六月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Jun', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }]
        }, {
            title: 'Jul 七月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Jul', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Jul',
                    key: 'Jul',
                    render: (text, record, index) => {
                        const title = [`Jul 七月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Jul', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }]
        }, {
            title: 'Aug 八月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Aug', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Aug',
                    key: 'Aug',
                    render: (text, record, index) => {
                        const title = [`Aug 八月- Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Aug', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }]
        }, {
            title: 'Sep 九月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Sep', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Sep',
                    key: 'Sep',
                    render: (text, record, index) => {
                        const title = [`Sep 九月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Sep', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }]
        }, {
            title: 'Oct 十月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Oct', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Oct',
                    key: 'Oct',
                    render: (text, record, index) => {
                        const title = [`Oct 十月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Oct', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }]
        }, {
            title: 'Nov 十一月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Nov', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Nov',
                    key: 'Nov',
                    render: (text, record, index) => {
                        const title = [`Nov 十一月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Nov', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }]
        }, {
            title: 'Dec 十二月',
            align: "center",
            width: 150,
            children: [{
                title: 'Actual 实际',
                align: "center",
                width: 150,
                children: [{
                    title: ({ 1: "High旺季", 2: "Shoulder平季", 3: "Low淡季" })[~~_.get(dataSelect, '0.Dec', 1)],
                    align: "center",
                    width: 150,
                    dataIndex: 'Dec',
                    key: 'Dec',
                    render: (text, record, index) => {
                        const title = [`Dec 十二月-Actual 实际`];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'Dec', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }]
            }]
        }, {
            title: <div>Whole Year Actual <br /> 全年实际</div>,
            align: "center",
            width: 200,
            dataIndex: 'whole',
            key: 'whole',
            render: (text, record, index) => {
                const title = [`Whole Year Actual 全年实际`];
                let html = null;
                if (percentData.includes(index)) {
                    if (Number(text || "0") >= 0) {
                        html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                    } else {
                        html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                    }
                } else {
                    if (Number(text || "0") >= 0) {
                        html = <span>{(Number(text || "0").toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                    } else {
                        html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                    }
                }
                return (
                    <Compared data={{ index: index + 1, key: 'whole', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                        <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                            {html}
                        </div>
                    </Compared >
                )
            }
        }, {
            title: <div>Variance - Next Year Forecast Vs. Budget </div>,
            width: 150,
            children: [{
                title: 'Jan 一月',
                align: "center",
                width: 150,
                children: [{
                    title: 'Actual 实际',
                    width: 150,
                    align: "center",
                    dataIndex: 'nextJan',
                    key: 'nextJan',
                    render: (text, record, index) => {
                        const title = [`Variance - Next Year Forecast Vs. Budget`, 'Jan 一月-Actual 实际'];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'nextJan', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }],
            }, {
                title: 'Feb 二月',
                align: "center",
                width: 150,
                children: [{
                    title: 'Actual 实际',
                    width: 150,
                    align: "center",
                    dataIndex: 'nextFeb',
                    key: 'nextFeb',
                    render: (text, record, index) => {
                        const title = [`Variance - Next Year Forecast Vs. Budget`, 'Jan 二月-Actual 实际'];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'nextFeb', title, sqlName: "_2_3", name: record.name, type: 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }],
            }, {
                title: 'Mar 三月',
                align: "center",
                width: 150,
                children: [{
                    title: 'Actual 实际',
                    width: 150,
                    align: "center",
                    dataIndex: 'nextMar',
                    key: 'nextMar',
                    render: (text, record, index) => {
                        const title = [`Variance - Next Year Forecast Vs. Budget`, 'Jan 三月-Actual 实际'];
                        let html = null;
                        if (percentData.includes(index)) {
                            if (Number(text || "0") >= 0) {
                                html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                            }
                        } else {
                            if (Number(text || "0") >= 0) {
                                html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                            } else {
                                html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                            }
                        }
                        return (
                            <Compared data={{ index: index + 1, key: 'nextMar', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                                <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                    {html}
                                </div>
                            </Compared >
                        )
                    }
                }],
            }, {
                title: 'Q1 第一季度',
                width: 150,
                align: "center",
                dataIndex: 'nextQ1',
                key: 'nextQ1',
                render: (text, record, index) => {
                    const title = ['Q1 第一季度'];
                    let html = null;
                    if (percentData.includes(index)) {
                        if (Number(text || "0") >= 0) {
                            html = <span>{((Number(text || "0") * 100).toFixed(1) + '%')}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({Math.abs(Number(text || "0") * 100).toFixed(1) + '%'})</span>
                        }
                    } else {
                        if (Number(text || "0") >= 0) {
                            html = <span>{(Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))}</span>
                        } else {
                            html = <span style={{ color: "red" }}>({(Math.abs(Number(text || "0")).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))})</span>
                        }
                    }
                    return (
                        <Compared data={{ index: index + 1, key: 'nextQ1', title, sqlName: "_2_3", name: record.name, type: percentData.includes(index) ? 'percent' : 'number' }}>
                            <div className={`table-color ${totalData.includes(index) ? 'table-color-footer' : ''}`}>
                                {html}
                            </div>
                        </Compared >
                    )
                }
            }]
        }];
        return (
            <Spin spinning={this.state.loading} >
                <div className="table table2_1">
                    <Row className="title" id="table2_3" style={{ width: this.state.print ? 3075 : 'auto' }}>
                        <Row>2.3 Last Year P&L Analysis (Whole Year Actual) 前一年度损益分析 （去年实际）</Row>
                        <Row className="table-month">
                            <Select
                                placeholder="请选择年份"
                                style={{ width: 120 }}
                                value={this.state.date}
                                onChange={(str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            >
                                {this.state.dateData.map((x, i) => {
                                    return (
                                        <Option value={x} key={x}>{x}</Option>
                                    )
                                })}
                            </Select>
                            <Auth isAdmin={true}>
                                <Button
                                    type="primary"
                                    loading={loading}
                                    style={{ marginLeft: 10, display: this.state.print ? 'none' : '' }}
                                    onClick={() => {
                                        this.setState({ loading: true }, async () => {
                                            await saveAllData(date);
                                            this.setState({ loading: false });
                                        })
                                    }}
                                >
                                    保存所有酒店数据
                                </Button>
                            </Auth>
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            className="content"
                            bordered
                            id="table"
                            pagination={false}
                            style={{ width: this.state.print ? 3025 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 3025, y: 550 }}
                            rowKey={(record, index) => {
                                return index
                            }}
                        />

                    </Row>
                    <Row className="table-footer-btn">
                        <Alert
                            message={
                                <div>
                                    表格关联
                                    <IsLableAuth auth="read_2_1" {...this.props} path="/table/2_1">2.1</IsLableAuth>
                                </div>
                            }
                            type="info"
                            showIcon
                            style={{ display: "inline-block", marginRight: 10 }}
                        />
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={this.onExpoetExcel}
                        >导出Excel</Button>
                        <Auth loading={this.state.loading} auth="edit_2_3">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>
                </div>
            </Spin>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-3/index.js